import type { TServiciosSlug } from '~~/constants';
import { BASE_SITE, SEO } from '~~/constants';

export interface SeoMetaParams {
  serviceName: string | undefined;
  serviceSlug: string | undefined;
  departureStationName: string | undefined;
  departureStationSlug: string | undefined;
  arrivalStationName: string | undefined;
  arrivalStationSlug: string | undefined;
  servicioParam: TServiciosSlug | undefined;
}

export interface SeoMetaOutput {
  title: string;
  titleTemplate: string;
  ogTitle: string;
  twitterTitle: string;
  description: string;
  ogDescription: string;
  twitterDescription: string;
}

export const buildSeoMeta = (p: SeoMetaParams): SeoMetaOutput => {
  const serviceName = p.serviceName || 'Biotren';
  const hasDeparture = !!p.departureStationName;
  const hasArrival = !!p.arrivalStationName;

  let title: string;
  let description: string;

  if (hasDeparture && hasArrival) {
    title = `${serviceName}: ${p.departureStationName} a ${p.arrivalStationName} — horarios y tarifas`;
    description = `Consulta los horarios y tarifas del ${serviceName} desde ${p.departureStationName} hasta ${p.arrivalStationName}. Información actualizada para planificar tu viaje.`;
  } else if (hasDeparture) {
    title = `${serviceName}: desde ${p.departureStationName} — horarios y tarifas`;
    description = `Revisa los horarios del ${serviceName} desde ${p.departureStationName}. Encuentra salidas, tarifas y tiempos de viaje.`;
  } else {
    const seoDescription = p.servicioParam
      ? SEO[p.servicioParam]?.description
      : SEO.biotren?.description;
    title = `${serviceName} — horarios, tarifas y estaciones`;
    description =
      seoDescription ||
      `Consulta horarios, tarifas y estaciones del ${serviceName}.`;
  }

  return {
    title,
    titleTemplate: `%s | ${BASE_SITE.NAME}`,
    ogTitle: title,
    twitterTitle: title,
    description,
    ogDescription: description,
    twitterDescription: description,
  };
};
